<template>
  <div class="container mt-5 text-center">
    <h3>Contratos</h3>
    <div v-if="loading" class="spinner-border mt-2" role="status">
      <span  class="sr-only">Loading...</span>
    </div>
      <div class="container">
        <div class="table-responsive">
          <table class="table" style="width:100% !important" >
            <thead>
              <tr>
                <th>Id</th>
                <th>Dirección</th>
                <th>diassemana</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.contra_id">
                <td class="text-center">{{ item.contra_id }}</td>
                <td class="text-center">{{ item.direccion1}}</td>
                <td class="text-center">{{ item.diassemana[0] }}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-primary" @click="showModal(item)">
                    Ver
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    <!-- </div> -->

  <div>
    <simple-modal v-model="isShow" title="Detalle">

      <template slot="body">
      
        <!-- <h5>Detalle</h5> -->
        <!-- <textarea v-model="row.descripcio" cols="55" rows="10" style="width:90%"></textarea> -->
        <!-- <p>Hello you</p> -->
        <br>
        <button @click="isShow= false" class="btn btn-primary mt-3">Cerrar</button>
      </template>
      
      <template slot="footer">
        <button>OK</button>
      </template>
    </simple-modal>
  </div>

  </div>
</template>

<script>
import SimpleModal from 'simple-modal-vue'

  import api from "../config/api";
  export default {
    components: { SimpleModal },
    data(){
      return{
        items:[],
        user: null,
        loading: false,
        isShow: false,
        row:{}
      }
    },
    async mounted(){
      this.$isLoading(true)
      this.user = JSON.parse(localStorage.getItem('user'));
      console.log('-->', this.user)
      await this.getData()
      this.$isLoading(false)

    },
    methods:{
      showModal(item){
        this.row = item
        this.isShow= true
      },
      async getData(){
        let resultv = await api.request("get", '/BMGES_obtenerContratos/' + this.user.numero);
        let res = resultv.data
        this.items = res
        //console.log('tareas', resultv)
      }
    }
  }

</script>

<style>

</style>